<style scoped>
  .silder{background-color:#FFF;border-right:solid 1px #d7dde4;width:200px}
  .silder-item{padding:0 5px;text-align: left;height:60px;margin:0 20px;font-size:14px;border-bottom:solid 1px #d7dde4;cursor: pointer;}
  .silder-item:hover{background-color:#f5fcff;color:#00a2e9}
  .silder-item:hover .tips-icon{display:inline-block}
  .tips-icon{font-size:20px;display: none}
  .task-panel{padding:0px 20px;border-bottom:1px dashed #d7dde4;}
  .stageTip{display: inline-block;vertical-align:middle;line-height: 1em}
  .silder-title{cursor:pointer;height: 60px;color:#00a2e9;line-height:60px;margin:0 6px;padding:0 18px;font-size:14px;border-bottom:1px solid #d7dde4}
</style>

<template>
  <div>
    <Layout>
      <Sider hide-trigger class="silder" style="width:300px;flex:0 0 300px;max-width:300px;padding-bottom: 50px;">
        <div class="silder-title" v-if="$route.query.filed!=1">
          <div @click="addStage()">
            <span style="background-color:#00a2e9">
              <Icon type="md-add" style="color: white"/>
            </span>
            添加阶段
          </div>
        </div>
        <div class="silder-item" v-if="model.stage.length>0" v-for="(item,index) in model.stage">
          <Input @on-blur="saveModel(item,index,'stage','编辑阶段标题')" v-if="item.edit==true" v-model="item.name" placeholder="请输入阶段名称"></Input>
          <Row type="flex" justify="center" v-else>
            <Col span="20">
              <div style="line-height:60px" @click="stageIndex=index">
                <div style="display: inline-block;vertical-align:middle;line-height: 1em">{{computeTask(item.task)}}/{{item.task.length}} {{item.name}}</div>
              </div>
            </Col>
            <Col span="4" style="line-height:60px" v-if="$route.query.filed!=1">
              <span class="tips-icon">
                <Icon type="ios-create-outline" @click="item.edit=1"/>
                <Icon type="ios-trash-outline" @click="deleteStage(index)"/>
              </span>
            </Col>
          </Row>
        </div>
      </Sider>
      <Sider hide-trigger class="silder" style="width:300px;flex:0 0 300px;max-width:300px">
        <div class="silder-title" @click="addTask()" v-if="$route.query.filed!=1">
          <span style="background-color:#00a2e9">
            <Icon type="md-add" style="color: white"/>
          </span>
          添加任务
        </div>
        <template v-if="model.stage.length>0">
          <div class="silder-item" v-for="(item,index) in model.stage[stageIndex].task" v-if="item.state==false">
            <Input @on-blur="saveModel(item,index,'task','编辑任务标题')" v-if="item.edit==true" v-model="item.name" placeholder="请输入任务名称"></Input>
            <Row type="flex" justify="center" v-else>
              <Col span="20">
                <div style="line-height:60px" @click="taskIndex=index">
                  <div @click="taskIndex=index">
                    <Checkbox @on-change="saveModel(undefined,undefined,undefined,'修改'+item.name+'任务完成状态')" v-model="item.state">&nbsp;</Checkbox>
                    <span class="stageTip" :style="item.state?'text-decoration:line-through':''" >{{item.name}}</span>
                  </div>
                </div>
              </Col>
              <Col span="4" style="line-height:60px">
                <span class="tips-icon" v-if="$route.query.filed!=1">
                  <Icon type="ios-create-outline" @click="item.edit=1"/>
                  <Icon type="ios-trash-outline" @click="deleteTask(index)"/>
                </span>
              </Col>
            </Row>
          </div>
          <div class="silder-item" v-for="(item,index) in model.stage[stageIndex].task" v-if="item.state==true">
            <Input @on-blur="saveModel(item,index,'task','编辑任务标题')" v-if="item.edit==true" v-model="item.name" placeholder="请输入任务名称"></Input>
            <Row type="flex" justify="center" v-else>
              <Col span="20">
                <div style="line-height:60px" @click="taskIndex=index">
                  <div @click="taskIndex=index">
                    <Checkbox @on-change="saveModel(undefined,undefined,undefined,'修改'+item.name+'任务完成状态')" v-model="item.state">&nbsp;</Checkbox>
                    <span class="stageTip" :style="item.state?'text-decoration:line-through':''" >{{item.name}}</span>
                  </div>
                </div>
              </Col>
              <Col span="4" style="line-height:60px">
                <span class="tips-icon">
                  <Icon type="ios-create-outline" @click="item.edit=1"/>
                  <Icon type="ios-trash-outline" @click="deleteTask(index)"/>
                </span>
              </Col>
            </Row>
          </div>
        </template>
      </Sider>
      <Layout>
        <Content style="background-color:#FFF;" v-if="model.stage.length>0&&model.stage[stageIndex].task.length>0">
          <div class="task-panel">
            <div style="padding:10px"></div>
            <span style="font-size:18px">{{model.stage[stageIndex].task[taskIndex].name}}{{model.stage[stageIndex].task[taskIndex].state?'(已完成)':''}}</span>
            <div style="padding:10px"></div>
          </div>
          <div class="task-panel">
            <div style="padding:15px"></div>
            <editor
                @on-blur="model.stage[stageIndex].task[taskIndex].content.advice = $event;saveModel(undefined,undefined,undefined,'修改任务指导')"
                :content="model.stage[stageIndex].task[taskIndex].content.advice"
                placeholder="请输入任务指导/说明"
            ></editor>
            <div style="padding:15px"></div>
          </div>
          <div class="task-panel">
            <div style="font-size:14px;line-height:50px;position:relative;">
              <Icon style="font-size:20px" type="ios-person-add-outline"/> 设置执行人
              <Dropdown trigger="click" placement="bottom-end" style="float: right;font-size:24px;">
                <Icon type="md-add-circle" />
                <DropdownMenu style="width:200px" slot="list">
                  <div style="text-align: center;font-size:14px;height:25px;line-height:25px;border-bottom:dashed 1px #d7dde4">选择律师</div>
                  <DropdownItem v-for="(item,index) in projectUser"><div @click="model.stage[stageIndex].task[taskIndex].content.executor.push(item.id);saveModel(undefined,undefined,undefined,'更新执行人')"><Icon type="md-add" />{{item.name}}</div></DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
            <div v-if="projectUser.length>0" v-for="(item,index) in model.stage[stageIndex].task[taskIndex].content.executor" style="background-color:rgb(243,243,243);line-height:40px;padding:0 15px;font-size:14px;margin-bottom:5px;">
              <Avatar :src="projectUser.find((secItem)=>{return secItem.id==item}).icon" style="height:25px;width:25px;margin-right:5px;line-height:25px;vertical-align: middle">{{projectUser.find((secItem)=>{return secItem.id==item}).name[0]}}</Avatar>
              <span style="vertical-align: middle">{{projectUser.find((secItem)=>{return secItem.id==item}).name}}</span>
              <Icon style="float:right;line-height:40px;font-size:20px;color:red" type="md-close-circle" @click="model.stage[stageIndex].task[taskIndex].content.executor.splice(index,1);saveModel(undefined,undefined,undefined,'删除执行人')"/>
            </div>
            <div style="padding:15px"></div>
          </div>
          <div class="task-panel">
            <div style="font-size:14px;line-height:50px;">
              <Icon style="font-size:20px" type="md-time"/> 建议任务完成时间
              <DatePicker v-model="model.stage[stageIndex].task[taskIndex].content.date" @on-change="model.stage[stageIndex].task[taskIndex].content.date=$event;saveModel(undefined,undefined,undefined,'修改任务完成时间')" style="display:inline-block"></DatePicker>
            </div>
          </div>
          <div class="task-panel">
            <div style="font-size:14px;line-height:50px;">
              <Icon style="font-size:20px" type="md-filing"/> 关联文件
            </div>
            <a
                target="_blank"
                v-for="(item,index) in model.stage[stageIndex].task[taskIndex].content.files"
                :href="getServerURL('default',false)+'/'+item.filesSrc"
                style="display: block;background-color:rgb(243,243,243);line-height:40px;padding:0 15px;font-size:14px;margin-bottom:5px;"
            >
              <Icon type="ios-cloud-download-outline" style="font-size:20px;margin-right:3px"/>
              <span style="vertical-align: middle">{{item.fileName}}</span>
              <Icon style="float:right;line-height:40px;font-size:20px;color:red" type="md-close-circle" @click="model.stage[stageIndex].task[taskIndex].content.files.splice(index,1);saveModel(undefined,undefined,undefined,'删除任务关联文件')"/>
            </a>
            <Upload
                multiple
                :show-upload-list="false"
                type="drag"
                :on-success="uploadSuccess"
                :on-remove="deleteFile"
                :headers="{GroupId:groupId,Con:'R',Fun:'upload_file',UserLogin:phoneNumber,UserToken:userToken,Ver:'v1'}"
                :data="{MenuId:menuId,UserId:userId}"
                :action="getServerURL('default',true)">
              <div style="padding: 20px 0">
                <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                <p>点击或拖拽文件到此处完成上传</p>
              </div>
            </Upload>
            <div style="padding:15px"></div>
          </div>
          <div class="task-panel">
            <div style="font-size:14px;line-height:50px;">
              <Icon style="font-size:20px" type="md-chatboxes" />评论
            </div>
            <template>
              <div style="padding-left:10px;">
                <Divider style="margin:10px 0" dashed />
                <span
                    v-if="model.stage[stageIndex].task[taskIndex].content.comment!=undefined&&projectUser.length>0"
                    v-for="(item,index) in model.stage[stageIndex].task[taskIndex].content.comment"
                    style="font-size:14px"
                >
                  <Avatar :src="allUserList.find((secItem)=>{return secItem.id==item.userId}).icon" style="height:25px;width:25px;margin-right:5px;line-height:25px;vertical-align: middle">{{allUserList.find((secItem)=>{return secItem.id==item.userId}).name[0]}}</Avatar>
                  <span style="vertical-align: middle">{{allUserList.find((secItem)=>{return secItem.id==item.userId}).name}}</span>
                  ：{{item.content}}
                  <span style="float: right;cursor: pointer;color: #00a2e9" @click="deleteComment(index)">删除</span>
                  <Divider style="margin:10px 0" dashed />
                </span>
                <Input search enter-button="发送" v-model="commentText" placeholder="输入评论" @on-search="addComment($event)"/>
              </div>
              <!--<div style="background-color:rgb(243,243,243);line-height:40px;padding:0 15px;font-size:14px;margin-bottom:5px;">-->
                <!--<Avatar style="height:25px;width:25px;margin-right:5px;vertical-align: middle"/>-->
                <!--<span style="vertical-align: middle">郭帅</span>-->
                <!--<Icon style="float:right;line-height:40px;font-size:20px;color:red" type="md-close-circle" />-->
              <!--</div>-->
              <!--<div style="background-color:rgb(243,243,243);line-height:40px;padding:0 15px;font-size:14px;margin-bottom:5px;">-->
                <!--<Avatar style="height:25px;width:25px;margin-right:5px;vertical-align: middle"/>-->
                <!--<span style="vertical-align: middle">郭帅</span>-->
                <!--<Icon style="float:right;line-height:40px;font-size:20px;color:red" type="md-close-circle" />-->
              <!--</div>-->
              <div style="padding:15px"></div>
            </template>
          </div>
        </Content>
      </Layout>
    </Layout>
  </div>
</template>

<script>
  import Editor from "../../../components/system/editor";
  export default {
    name: "task",
    components: {Editor},
//任务
    data () {
      return {
        oldModel:'',
        commentText:"",
        model:{
          stage:[],
        },
        stageIndex:0,
        taskIndex:0,
        projectUser:[],
        temp:{
          commentText:'',
        },
        allUserList:[],
      }
    },
    watch:{
      'stageIndex':function () {
        this.taskIndex=0
      }
    },
    mounted:function(){
      this.getUserList()
      this.getAllUserList()
      this.getModel()
    },
    methods : {
      deleteComment:function(index){
        var _this = this
        _this.$Modal.confirm({
          title:'系统消息',
          content:'是否确认当前操作？',
          onOk:function () {
            _this.model.stage[_this.stageIndex].task[_this.taskIndex].content.comment.splice(index,1)
            _this.saveModel(undefined,undefined,undefined,'删除评论')
          },
        })
      },
      addComment:function(val){
        if(this.model.stage[this.stageIndex].task[this.taskIndex].content.comment==undefined){
          this.model.stage[this.stageIndex].task[this.taskIndex].content.comment = []
        }
        this.model.stage[this.stageIndex].task[this.taskIndex].content.comment.push({
          userId:this.userId,
          content:val
        })
        this.saveModel(undefined,undefined,undefined,'增加评论')
        this.commentText = ""
      },
      //添加阶段
      addStage:function(){
        this.model.stage.push({name:'',edit:true,task:[]})
      },
      //添加任务
      addTask:function(){
        if(this.model.stage.length>0) {
          this.model.stage[this.stageIndex].task.push({
            name: '',
            edit: true,
            state: false,
            content:{
              advice:'',
              date:'',
              files:[],
              executor:[],
              comment:[],
            }
          })
        }
      },
      //删除阶段
      deleteStage:function(index){
        var _this = this
        _this.$Modal.confirm({
          title:'系统消息',
          content:'是否确认当前操作？',
          onOk:function () {
            _this.model.stage.splice(index,1)
            _this.saveModel()
          },
        })
      },
      //删除任务
      deleteTask:function(index){
        var _this = this
        _this.$Modal.confirm({
          title:'系统消息',
          content:'是否确认当前操作？',
          onOk:function () {
            _this.model.stage[_this.stageIndex].task.splice(index,1)
            _this.stageIndex = 0
            _this.saveModel(undefined,undefined,undefined,'删除任务:'+_this.model.stage[_this.stageIndex].task.name)
          },
        })
      },
      //删除文件
      deleteFile:function(file,fileList){
        this.model.stage[this.stageIndex].task[this.taskIndex].content.files = []
        for(var i=0;i<fileList.length;i++){
          this.model.stage[this.stageIndex].task[this.taskIndex].content.files.push({
            fileName:fileList[i].response.Data.name,
            filesSrc:fileList[i].response.Data.path,
          })
        }
        this.saveModel()
      },
      //上传文件成功回调
      uploadSuccess:function (response,file,fileList) {
        this.model.stage[this.stageIndex].task[this.taskIndex].content.files.push({
          fileName:response.Data.name,
          filesSrc:response.Data.path,
        })
        this.saveModel()
        this.$Notice.success({
          title:'系统提示',
          desc:'文件上传成功！'
        })
      },
      //获取项目数据
      getModel:function () {
        var _this = this
        _this.send({
          headers:'C/ShowMissionById',
          data:{
            CaseId:_this.$route.query.caseId,
          },
          success:function (res) {
            if(typeof res.MissionContent != 'string'&&Boolean(res.MissionContent)){
              _this.$set(_this.model,'stage',res.MissionContent)
              _this.oldModel = JSON.stringify(res.MissionContent)
            }else{

            }
          }
        })
      },
      //保存项目数据
      saveModel:function (item,index,type,history) {
        if(item!=undefined){item.edit=0}
        if(type=='stage'){this.stageIndex = index}
        if(type=='task'){this.taskIndex = index}
        if(JSON.stringify(this.model.stage).length==this.oldModel.length){
          history = ''
        }
        var completeNum = 0
        for(var i=0; i<this.model.stage.length;i++){
          for(var j=0;j<this.model.stage[i].task.length;j++){
            if(this.model.stage[i].task[j].state==true){
              completeNum++
            }
          }
        }
        var _this = this
        _this.send({
          headers:'C/EditMission',
          data:{
            CaseActionDetailContent:_this.model.stage,
            MissionId:_this.$route.query.taskId,
            MissionComplete:completeNum,
            Comment:history,
          }
        })
      },
      //计算完成任务
      computeTask:function(task){
        var completeNum = 0
        for(var i=0;i<task.length;i++){
          if(task[i].state==true){
            completeNum++
          }
        }
        return completeNum
      },
      //获取所有用户数据
      getAllUserList:function(searchText){
        var _this = this
        _this.userList = []
        _this.send({
          headers:'C/LawList',
          data:{
            key:searchText||'',
          },
          success:function (res) {
            var tempObj = []
            for(var index in res){
              tempObj.push({id:res[index].UserId,name:res[index].UserName,icon:res[index].UserImg})
            }
            _this.allUserList = tempObj
          }
        })
      },
      //获取项目内用户列表
      getUserList:function() {
        var _this = this
        _this.projectUser = []
        _this.send({
          headers:'E/CaseLawList',
          data:{
            key:'',
            CaseId:_this.$route.query.caseId
          },
          success:function (res) {
            for(var index in res){
              for(var secIndex in res[index]){
                _this.projectUser.push({
                  id:res[index][secIndex].UserId,
                  name:res[index][secIndex].UserName,
                  icon:res[index][secIndex].UserImg||'',
                })
              }
            }
          }
        })
      },
    },
    computed:{
      phoneNumber:function () {
        return window.sessionStorage.phoneNumber
      },
      userToken:function () {
        return window.sessionStorage.userToken
      },
      groupId:function () {
        return window.sessionStorage.groupId
      },
      menuId:function () {
        return window.sessionStorage.menuId
      },
      userId:function () {
        return window.sessionStorage.userId
      },
    }
  }
</script>
